import { render, staticRenderFns } from "./authGroup.vue?vue&type=template&id=e4f70662&scoped=true&lang=pug"
import script from "./authGroup.vue?vue&type=script&lang=js"
export * from "./authGroup.vue?vue&type=script&lang=js"
import style0 from "./authGroup.vue?vue&type=style&index=0&id=e4f70662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f70662",
  null
  
)

export default component.exports